module.exports = __webpack_public_path__ + "img/product-tutorial-3.74cafecf.png";